/**
 * 微信 JS-SDK 分享工具
 */

// 检测是否在微信环境中
export function isWechat() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1
}

// 加载微信 JS-SDK
export function loadWechatSdk() {
  return new Promise((resolve, reject) => {
    if (window.wx) {
      resolve(window.wx)
      return
    }
    const script = document.createElement('script')
    script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
    script.onload = () => resolve(window.wx)
    script.onerror = reject
    document.head.appendChild(script)
  })
}

// 获取微信签名
export async function getWechatSignature(url) {
  // 使用相对路径，同域名下直接请求
  const res = await fetch(`/api/v1/wechat/signature?url=${encodeURIComponent(url)}`)
  const data = await res.json()
  if (data.code !== 0) {
    throw new Error(data.message || '获取签名失败')
  }
  return data.data
}

// 初始化微信 JS-SDK
export async function initWechat() {
  // 开发环境下跳过微信SDK初始化（IP不在白名单会报错）
  if (process.env.NODE_ENV === 'development') {
    console.log('[开发模式] 跳过微信SDK初始化')
    return null
  }

  try {
    const wx = await loadWechatSdk()
    // 获取当前页面URL（不含hash），用于签名
    const currentUrl = window.location.href.split('#')[0]
    console.log('微信签名URL:', currentUrl)
    const signature = await getWechatSignature(currentUrl)
    console.log('微信签名结果:', signature)

    wx.config({
      debug: false,
      appId: signature.appId,
      timestamp: signature.timestamp,
      nonceStr: signature.nonceStr,
      signature: signature.signature,
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData'
      ]
    })

    return new Promise((resolve) => {
      wx.ready(() => {
        console.log('微信JS-SDK配置成功')
        resolve(wx)
      })
      wx.error((err) => {
        console.error('微信JS-SDK配置失败:', err)
        resolve(null)
      })
    })
  } catch (err) {
    console.error('初始化微信SDK失败:', err)
    return null
  }
}

// 设置分享内容
export function setShareData(wx, options) {
  if (!wx) return

  // 默认分享图标
  const defaultImgUrl = window.location.origin + '/logo.png'

  const shareData = {
    title: options.title || '数聚吴川',
    desc: options.desc || '数据驱动，惠民到家',
    link: options.link || window.location.href,
    imgUrl: options.imgUrl || defaultImgUrl
  }

  // 分享给朋友
  wx.updateAppMessageShareData(shareData)

  // 分享到朋友圈
  wx.updateTimelineShareData({
    title: shareData.title,
    link: shareData.link,
    imgUrl: shareData.imgUrl
  })
}
